import { PoiTypeOutputWithStatus } from './poi-type-output-with-status.model';


export class PoiTypeSelectByIdOutput implements IPoiTypeSelectByIdOutput {
    status!: number;
    message!: string;
    data!: PoiTypeOutputWithStatus;

    constructor(data?: IPoiTypeSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? PoiTypeOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PoiTypeSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PoiTypeSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IPoiTypeSelectByIdOutput {
    status: number;
    message: string;
    data: PoiTypeOutputWithStatus;
}

